import React from "react";
import { AppContext } from "../../App";
import { useContext } from "react";



// Import Css
import './cardComponents.css';

// Import Assets
import photoSoluciones1 from '../../assets/homeAssets/photo-soluciones/photo-soluciones-1.jpg';




export default function CardComponents({photoSolution, titleSolution, textSolucion}) {


    // Background Portada Home
    const styleBkphotoSoluciones = {
        backgroundImage: `url(${photoSolution})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
  
    
    }


    return (

        <div className="card-component-container"> 

            <div className="box-photo-solucion" style={styleBkphotoSoluciones}>
                
                
            </div>
        
            <div className="box-text-solucion">
        
                <h3 className="title-solucion">{titleSolution}</h3>
                <p className="text-solucion">{textSolucion}</p>

            </div>

        </div>

    );


}